import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatButton } from '@angular/material/button'
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'


import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { DocumentTypeService } from '../../../core/services/document/document-type/document-type.service'
import { MatIconModule } from '@angular/material/icon'
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionModule } from '@angular/material/expansion'
import { MatDatepicker, MatDatepickerModule, MatDateRangePicker } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common';
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatTableModule } from '@angular/material/table'
import { MatPaginator } from '@angular/material/paginator'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { PassengerService } from '../../../core/services/passenger/passenger.service'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { PassengerOrdemService } from '../../../core/services/passenger/passenger-os/passenger-os.service'
import { MatSpinner } from '@angular/material/progress-spinner'
import { debounceTime, distinctUntilChanged, filter } from 'rxjs'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { OccurrenceTypeService } from '../../../core/services/occurrence/occurrence-type/occurrence-type.service'
import { OccurrenceService } from '../../../core/services/occurrence/occurrences/occurrences.service'
import { OccurrenceOsService } from '../../../core/services/occurrence/occurrences-os/occurrences-os.service'
import { OccurrencesModalEditComponent } from "../occurrences-modal-edit/occurrences-modal-edit.component";
import { OccurrencesModalCreateComponent } from "../occurrences-modal-create/occurrences-modal-create.component";
import { MatDividerModule } from "@angular/material/divider";

@Component({
  selector: 'occurrences-modal-table',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskDirective,
    MatSpinner,
    TableListComponent,
    OccurrencesModalEditComponent,
    OccurrencesModalCreateComponent,
    MatProgressBar,
    MatExpansionModule,
    MatDividerModule
  ],
  templateUrl: './occurrences-modal-table.component.html',
  styleUrl: './occurrences-modal-table.component.scss',
  standalone: true,
  providers: [provideNgxMask({
    dropSpecialCharacters: false
  })],
})
export class OccurrencesModalTableComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<OccurrencesModalTableComponent>,
    private dialog: MatDialog,
    private passangerService: PassengerService,
    private passangerOs: PassengerOrdemService,
    private documentTypeService: DocumentTypeService,
    private snackbar: SnackbarCustomService,
    private occurrenceTypeService: OccurrenceTypeService,
    private occurrenceService: OccurrenceService,
    private occurrenceOsService: OccurrenceOsService,
  ) { }

  @Output() response = new EventEmitter<any>()

  form!: FormGroup;
  passengers: any[] = []; // Agora a lista vem da API
  loading: boolean = false;

  documentMask: string = '';

  columns: any[] = [
    // { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'descricaoTipoOcorrencia',
      key: 'descricaoTipoOcorrencia',
      description: 'Tipo Ocorrência',
    },
    {
      keyColumn: 'descricaoOcorrencia',
      key: 'descricaoOcorrencia',
      description: 'Ocorrência',
    },
    {
      keyColumn: 'dataOcorrido',
      key: 'dataOcorrido',
      description: 'Data',
    },
    {
      keyColumn: 'horaOcorrido',
      key: 'horaOcorrido',
      description: 'Hora',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: true, view: true },
      description: 'Ações',
    },
  ]

  edit: boolean = false
  listTypeOccurrence: any = []
  listOccurrence: any = []
  page: number = 1;
  rows: number = 10;
  numberRows: number = 0;
  itemsList: any[] = []
  passengerOsList: any[] = []
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  idForOs: any = ""
  editIndex: number | null = null;
  editAgendaItem: any = null;

  ngOnInit(): void {
    this.listOccurrencesOs()
    this.createForm();
    this.listTypeOccurrences()
    this.listOcccurrences()
  }

  viewItem(item: any) {
    this.dialog.open(OccurrencesModalEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '850px',
      width: '850px',
      maxHeight: '460px',
      height: '460px',
      data: { item, codigoTG: this.data.codigoTg }
    })
  }

  newOccurrence() {
    const dialogRef = this.dialog.open(OccurrencesModalCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '850px',
      width: '850px',
      maxHeight: '500px',
      height: '500px',
      data: this.data
    })
    dialogRef.componentInstance.response.subscribe((res) => {
      if (res) {
        this.listOccurrencesOs()
      }
    })
  }


  listOccurrencesOs() {
    this.loading = true
    const item = {
      ordemServicoId: this.data.codigoOs
    }

    this.occurrenceOsService.searchPagedOccurrenceServiceOrder(this.page, this.rows, item).subscribe({
      next: (res) => {
        this.loading = false
        this.treatResponse(res)
      },
      error: (error: any) => {
        this.snackbar.error(error.message)
      }
    })
  }

  listOcccurrences() {
    this.occurrenceService.listOccurrence().subscribe({
      next: (res) => {
        this.listOccurrence = res.data
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  listTypeOccurrences() {
    this.occurrenceTypeService.listOccurrenceType().subscribe({
      next: (res) => {
        this.listTypeOccurrence = res.data
      },
    })
  }

  registerOccurrences() {
    const data = this.createModal()

    this.occurrenceOsService.createOccurrenceServiceOrder(data).subscribe({
      next: (res) => {
        this.snackbar.success(res.message)
        this.response.emit(res)
        this.closeModal()
      },
      error: (error: any) => {
        this.snackbar.error(error.message)
      }
    })
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      codeOs: this.data.codigoOs,
      codeTg: this.data.codigoTg,
      typeOccurrence: [''],
      occurrence: [''],
      date: [''],
      hour: [''],
      observation: [''],
    });
  }


  //Formatar a data que vem como string 00/00/00 para o formato que o input mat-datapciker aceita
  formatDate(dateString: string): Date | null {
    const dateParts = dateString.split('/');
    if (dateParts.length === 3) {
      const day = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1;
      const year = parseInt(dateParts[2], 10);
      return new Date(year, month, day);
    }
    return null;
  }



  closeModal() {
    this.dialogRef.close();
  }


  getListItems() {
    this.loading = true
    this.passangerService
      .listPagedPassenger(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }

  formatHour(time: any): string {
    if (!time) return '';
    return time.slice(0, 5)
  }


  treatResponse(response: any) {
    let list = []
    console.log(response.data)
    if (response.data) {
      for (let item of response.data) {

        if (item.horaOcorrido) {
          item.horaOcorrido = this.formatHour(item.horaOcorrido)
        }

        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  formatDateBase(date: string): string {
    const dateObject = new Date(date);
    const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
    return `${dateObject.getDate()}/${month}/${dateObject.getFullYear()}`;
  }




  createModal() {
    return {
      ordemServicoId: this.form.get('codeOs')?.value,
      tipoOcorrenciaId: this.form.get('typeOccurrence')?.value,
      ocorrenciaId: this.form.get('occurrence')?.value,
      dataOcorrido: this.formatDateBase(this.form.get('date')?.value),
      horaOcorrido: this.formatHour(this.form.get('hour')?.value),
      observacao: this.form.get('observation')?.value
    }
  }


  getPassengersFromApi(): void {
    this.loading = true;


    this.passangerOs.listPagedPassengerOs(this.page, this.rows).subscribe({
      next: (res) => {


        this.passengers = res.data || [];
        this.numberRows = res?.data?.length || 0;
        this.loading = false;


      },
      error: () => {
        this.loading = false;
        console.error('Erro ao buscar passageiros');
      }
    });
  }




  deleteItem(item: any) {
    this.occurrenceOsService.deleteOccurrenceServiceOrder(item.id).subscribe({
      next: (res) => {
        this.snackbar.success(res.message)
        this.listOccurrencesOs()
      },
      error: (error: any) => {
        this.snackbar.error(error.message)
      }
    })
  }


  resetForm() {
    this.form.reset();
  }
}
